// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const DoneIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 20 20">
    <circle cx={10} cy={10} r={9} stroke="currentColor" strokeWidth={1.5} />
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m6.25 10.41 2.96 2.97 4.5-6.76"
    />
  </svg>,
  "Done",
);
export default DoneIcon;
